// react-i18next bootstrap. Translation JSONs are vendored under src/assets/i18n and
// imported statically so we never make an HTTP request for them (mirrors Angular's
// runtime-loaded bundles without going through the API base URL).
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { appConfig } from '@/api/appConfig';
import en from '@/assets/i18n/en.json';
import fr from '@/assets/i18n/fr.json';

const savedLang =
  typeof localStorage !== 'undefined' ? localStorage.getItem('lang') : null;

void i18n.use(initReactI18next).init({
  lng: savedLang ?? appConfig.defaultLanguage,
  fallbackLng: appConfig.defaultLanguage,
  supportedLngs: ['en', 'fr'],
  interpolation: { escapeValue: false },
  resources: {
    en: { translation: en },
    fr: { translation: fr },
  },
  react: {
    useSuspense: false,
  },
});

export function changeLanguage(lng: string): void {
  localStorage.setItem('lang', lng);
  void i18n.changeLanguage(lng);
}

export default i18n;
